
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

@Options({
  methods: {
    ...mapMutations(['SET_PAGE']),
    handleStart() {
      this.SET_PAGE(2);
      const $audio: any = document.getElementById('audio');
      $audio.play();
    },
  },
})
export default class IndexPage extends Vue {

}
